import React from 'react';
import { createRoot } from 'react-dom/client';

import FriendFormModal from '@/components/Modals/FriendFormModal';
import { FriendFormContent } from '@/components/Forms/FriendForm';

interface ModalFriendOptions {
  root: string;
  button: string;
  content: FriendFormContent;
}

const initModalFriend = (options: ModalFriendOptions, lang: string, objectId: string): void => {
  const container = document.getElementById(options.root);

  if (!container) {
    return;
  }

  // eslint-disable-next-line no-underscore-dangle
  const { recaptchaSiteKey, recaptchaDisabled } = window.__config__;

  const root = createRoot(container);

  root.render(
    <FriendFormModal
      button={options.button}
      content={options.content}
      lang={lang}
      objectId={objectId}
      recaptchaSiteKey={recaptchaSiteKey}
      recaptchaDisabled={recaptchaDisabled}
    />
  );
};

export default initModalFriend;
